import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, CircularProgress } from '@mui/material';
import { AddCircleOutline, BorderColor } from '@mui/icons-material';
import { previousTab } from '../../../../../../../../app/store/slices/event/event';
import ImageFileInput from '../../../../../../../../components/FormFields/ImageFileInput';
import CropImage from '../../../../../../../../components/EventDetails/media/Crop';
import useMedia from '../../../hooks/useMedia';
import { H4, H6, Body3 } from '../../../../../../../../themes/typography';
import '../../../../../../../../styles/components/Media.css';

// TODO: => Use created event_id from backend to show the edit button in draft, publish and if user purchase any ticket.
// Creation flow edit button will not be there

export default function Media() {
    const dispatch = useDispatch();
    const {
        loading,
        formik,
        cropType,
        isEditModeOn,
        setIsEditModeOn,
        cropImage,
        banner,
        eventLayout,
        eventThumbnail,
        eventGalleryImages,
        eventGalleryScrollRef,
        removeBanner,
        onCropClose,
        addGalleryImage,
        removeEventLayout,
        handleCropComplete,
        removeEventThumbnail,
        removeEventGalleryImage,
        handleEventLayoutChange,
        handleGalleryImageChange,
        handleEventThumbnailChange,
        handleEventBannerChange,
        shouldShowEditButton
    } = useMedia();

    return (
        <React.Fragment>
            <form className="event-media-uploder-container" onSubmit={formik.handleSubmit}>
                <div className="media-uploader-main-container">
                    {shouldShowEditButton && (
                        <div style={editBtnStyle}>
                            <Button
                                startIcon={<BorderColor />}
                                variant="text"
                                onClick={() => setIsEditModeOn(true)}
                                disabled={isEditModeOn}
                            >
                                Edit
                            </Button>
                        </div>
                    )}

                    <div className="media-uploader-form-starts">
                        <div className="thumbnail-layout-image-container">
                            {/* Event Thumbnail Container */}
                            <div className="thumbnail-images-container">
                                <H4>Event Thumbnail *</H4>
                                <div className="thumbnail-input-container">
                                    <div className="event-thumbnail-upload">
                                        <ImageFileInput
                                            disabled={!isEditModeOn}
                                            preview={eventThumbnail?.previewUrl}
                                            onFileSelect={handleEventThumbnailChange}
                                            onFileRemove={removeEventThumbnail}
                                            recommendedDimensions="(Recommended 320px x 320px)"
                                            imageInputStyle={{
                                                borderRadius: '50px 50px 10px 10px',
                                                height: '320px',
                                                width: '320px'
                                            }}
                                            mainInputContainer={{
                                                width: 'auto'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Event Layout Container */}
                            <div className="layout-image-container">
                                <H4>Event Layout</H4>
                                <div className="thumbnail-input-container">
                                    <div className="event-thumbnail-upload">
                                        <ImageFileInput
                                            disabled={!isEditModeOn}
                                            preview={eventLayout?.previewUrl}
                                            onFileSelect={handleEventLayoutChange}
                                            onFileRemove={removeEventLayout}
                                            recommendedDimensions="(Recommended 439px x 247px)"
                                            imageInputStyle={{
                                                borderRadius: '2rem',
                                                height: '247px',
                                                width: '439px'
                                            }}
                                            mainInputContainer={{
                                                width: 'auto'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="event-gallary-images-container" style={{ gap: '0.5rem' }}>
                            <H4>Event Banner</H4>
                            <div className="event-banner-container">
                                <div className="event-banner-image">
                                    <ImageFileInput
                                        disabled={!isEditModeOn}
                                        preview={banner?.previewUrl}
                                        onFileSelect={handleEventBannerChange}
                                        onFileRemove={removeBanner}
                                        recommendedDimensions="(Recommended 1920px x 1080px)"
                                        mainInputContainer={{
                                            width: '100%',
                                            maxWidth: '100%',
                                            height: '100%'
                                        }}
                                        imageInputStyle={{
                                            height: '100%',
                                            borderRadius: '50px'
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="event-gallary-images-container">
                            <H4>Event Gallary</H4>
                            <div className="event-gallery-add-image-container">
                                {/* main event gallery image container (scrollable) */}
                                <div className="event-gallery" ref={eventGalleryScrollRef}>
                                    {eventGalleryImages.map((image, index) => (
                                        <div className="event-gallery-image" key={index}>
                                            <div className="image-index-container">
                                                <H6>{index + 1}.</H6>
                                            </div>
                                            <div className="gallary-image-container">
                                                <div className="galley-image">
                                                    <ImageFileInput
                                                        disabled={!isEditModeOn}
                                                        onFileRemove={() =>
                                                            removeEventGalleryImage(index)
                                                        }
                                                        onFileSelect={(file) =>
                                                            handleGalleryImageChange(file, index)
                                                        }
                                                        preview={image?.previewUrl}
                                                        recommendedDimensions="(Recommended 1920px x 1080px)"
                                                        mainInputContainer={{
                                                            width: '100%',
                                                            maxWidth: '100%',
                                                            height: '100%'
                                                        }}
                                                        imageInputStyle={{
                                                            height: '100%',
                                                            borderRadius: '50px'
                                                        }}
                                                    />
                                                </div>

                                                {/* Image action buttons container */}
                                                <div className="image-action-buttons-container"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Add image to gallery container */}
                                <div className="add-image-to-gallery-container">
                                    <div
                                        className="add-image-icon"
                                        onClick={addGalleryImage}
                                        // style={{ pointerEvents: isEditModeOn ? 'auto' : 'none' }}
                                    >
                                        <AddCircleOutline sx={{ color: '#F8A21E', fontSize: 32 }} />
                                    </div>
                                    <div className="add-max-image">
                                        <Body3 color="#26c1e8">Max 3 Images</Body3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Back and Submit */}
                <div className="submit-button-container">
                    <Button variant="text" onClick={() => dispatch(previousTab())}>
                        Back to Description
                    </Button>
                    <Button variant="main" disabled={loading} type="submit">
                        {/* {isEditModeOn ? 'Save' : 'Next'} */} Next
                        {loading && (
                            <CircularProgress
                                size={20}
                                sx={{ marginLeft: '0.75rem', color: 'var(--primary-color)' }}
                            />
                        )}
                    </Button>
                </div>
            </form>

            {/* Image Cropper Modal Popup */}
            <CropImage
                isOpen={!!cropImage}
                onClose={onCropClose}
                image={cropImage}
                aspectRatio={
                    cropType === 'thumbnail' ? 1 : cropType === 'layout' ? 439 / 247 : 16 / 9
                }
                width={cropType === 'thumbnail' ? 320 : cropType === 'layout' ? 439 : 1920}
                height={cropType === 'thumbnail' ? 320 : cropType === 'layout' ? 247 : 1080}
                onCropComplete={handleCropComplete}
            />
        </React.Fragment>
    );
}

const editBtnStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    paddingBottom: '0.5rem'
};
